import CircularProgress from '@mui/material/CircularProgress'
import styles from './UsageIndicator.pcss'

const PERCENT = 100
const PROGRESS_SIZE = 18

interface UsageIndicatorProps {
  used: number
  total: number
  className?: string
}

export function UsageIndicator({ used, total, className }: UsageIndicatorProps) {
  const progress = (used / total) * PERCENT

  return (
    <div className={`${styles.usage}${className ? ` ${className}` : ''}`}>
      <span className={styles['progress-track']}>
        <CircularProgress variant="determinate" value={100} size={PROGRESS_SIZE} className={styles['progress-bg']} />
        <CircularProgress variant="determinate" color="primary" value={progress} size={PROGRESS_SIZE} />
      </span>
      <span>{used}/{total} requests</span>
    </div>
  )
}

export default UsageIndicator
